/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

/**
 * Selected wording for the `venue` term.
 */
export type VenueTerm = (typeof VenueTerm)[keyof typeof VenueTerm];

export const VenueTerm = {
  venue: "venue",
  member: "member",
} as const;
